/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
    ControlcenterMelcoModelsSerialNumberListItem,
    ControlcenterMelcoModelsSerialNumberListItemFromJSON,
    ControlcenterMelcoModelsSerialNumberListItemFromJSONTyped,
    ControlcenterMelcoModelsSerialNumberListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItem
 */
export interface ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItem {
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsSerialNumberListItem>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItem
     */
    list: Array<ControlcenterMelcoModelsSerialNumberListItem>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItem
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItem
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItemFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItem {
    return ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItemFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoModelsSerialNumberListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItemToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoModelsSerialNumberListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


